import React from "react";
import Card from "components/card";
import LineChart from "components/charts/LineChart";

const SODActivityChart = ({ data, title = "Daily Activity" }) => {
  console.log('SODActivityChart data:', data);
  if (!data || data.length === 0) {
    return (
      <Card extra="p-4">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4 font-dm">
          {title}
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400">No data available</p>
        </div>
      </Card>
    );
  }

  const chartData = data.map(item => ({
    name: item.date,
    "Total Requests": parseInt(item.record_count),
    "Edits": parseInt(item.edits_count || 0),
    "Creations": parseInt(item.no_edits_count || 0)
  }));

  return (
    <Card extra="p-4">
      <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4 font-dm">
        {title}
      </h4>
      <LineChart
        series={[
          {
            name: "Total Requests",
            data: chartData.map(item => item["Total Requests"])
          },
          {
            name: "Edits",
            data: chartData.map(item => item["Edits"])
          },
          {
            name: "Creations",
            data: chartData.map(item => item["Creations"])
          }
        ]}
        options={{
          legend: {
            position: "top",
            fontFamily: "DM Sans, sans-serif"
          },
          // Moderately dark but lighter color palette
          colors: ["#2563EB", "#10B981", "#EF4444"],
          chart: {
            height: 300,
            type: "line",
            toolbar: {
              show: false,
            },
            fontFamily: "DM Sans, sans-serif"
          },
          xaxis: {
            categories: chartData.map(item => item.name),
            type: "category",
          },
          yaxis: {
            type: "value",
          },
        }}
      />
    </Card>
  );
};

export default SODActivityChart; 